module.exports = __webpack_public_path__ + "img/horizontal_5_1_8019.d151eeb7.png";